import React from 'react';
import LavvaDetailsWrapper from '../../../../../components/details-wrapper';
import { ChannelType } from '../../../enums';
import { CentralActionType } from '../../../modules/groups/types';
import { CentralActionBlindDetailsControlsBox } from './blind/control-box';
import { CentralActionFacadeDetailsControlBox } from './facade/control-box';
import { CentralActionLightDetailsControlBox } from './light/control-box';
import { CentralActionSwitchDetailsControlBox } from './switch/control-box';

type CentralActionDetailsControlProps = {
  centralAction: CentralActionType;
};

export const CentralActionDetailsControl: React.FC<CentralActionDetailsControlProps> = ({ centralAction }) => {
  const renderActionControl = () => {
    switch (centralAction.type) {
      case ChannelType.Blind:
        return <CentralActionBlindDetailsControlsBox channels={centralAction.items} />;
      case ChannelType.Facade:
        return <CentralActionFacadeDetailsControlBox channels={centralAction.items} />;
      case ChannelType.Switch:
        return <CentralActionSwitchDetailsControlBox channels={centralAction.items} />;
      case ChannelType.Light:
        return <CentralActionLightDetailsControlBox channels={centralAction.items} />;
      default:
        return null;
    }
  };

  return (
    <div className="action-control">
      <LavvaDetailsWrapper>{renderActionControl()}</LavvaDetailsWrapper>
    </div>
  );
};
